const featuredProducts = [
    {
        id: "5",
        name: "OutDoor Sneakers",
        price: "12.69",
        imageURL: "../images/sneakers/sneakers04.webp",
        qty: 1
    },

    {
        id: "7",
        name: "EliteMen Quartz",
        price: "17.99",
        imageURL: "../images/wristwatches/ww02.webp",
        qty: 1
    },

    {
        id: "8",
        name: "Classic Lux",
        price: "6.13",
        imageURL: "../images/Leather Shoes/ls05.webp",
        qty: 1
    },

]
export default featuredProducts